import "../searchfield/styles/autocomplete";
import "./styles/style";

import { Track } from "../../common/track";
import { Autocomplete } from "../searchfield/scripts/autocomplete";
import { Datepickers } from "../searchfield/scripts/datepickers";

export default class Iframe {
  public static load(): void {
    Autocomplete.load_autocomplete_fields();
    Datepickers.load_datepickers();

    $("select.custom").selectmenu();

    $(":radio").on("click", (eventObject: JQueryEventObject): void => {
      const target: JQuery<HTMLElement> = $(eventObject.target);
      if (target.attr("data-redirect")) {
        window.top.location.href = target.attr("data-redirect");
      }
    });

    $("#air_form_iframe")
      .off("ajax:success")
      .on("ajax:success", (xhr, data, status): void => {
      if (data && data.url) {
        window.top.location.href = data.url;
      } else {
        Iframe.showError();
      }
    });

    $("#air_form_iframe")
      .off("ajax:failure ajax:error")
      .on("ajax:failure ajax:error", (xhr, status, error): void => {
      Iframe.showError();
    });
  }

  private static showError(): void {
    $(".search_box_overlay").hide();
    $(".search_box_overlay_top").hide();
    Track.log("AJAX ERROR");
  }
}
